module.exports = __webpack_public_path__ + "static/BoatRace17-f16528c96963071178d3d3304f19a4da.jpg";